import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import nl from './locales/nl.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

const STORAGE_KEY = 'web2pdf_lang';

const savedLang = localStorage.getItem(STORAGE_KEY);
const browserLang = navigator.language?.slice(0, 2);
const supported = ['en', 'nl', 'fr', 'de'];
const defaultLang = supported.includes(savedLang)
  ? savedLang
  : supported.includes(browserLang)
    ? browserLang
    : 'nl';

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, nl: { translation: nl }, fr: { translation: fr }, de: { translation: de } },
    lng: defaultLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lng) => localStorage.setItem(STORAGE_KEY, lng));

export default i18n;
